<template>
    <el-row class="container_self">
        <el-row class="table_parent">
            <el-row class="add_btn"><el-button type="primary" icon="el-icon-plus" size="mini" @click="createUser" v-if="permissions.indexOf(17)!=-1">新增角色</el-button></el-row>
            <el-row>
                <el-table :data="tableData"  style="width: 100%; margin-top: 10px"  v-loading="loading"  element-loading-text="加载中，请稍后">
                    <el-table-column prop="name" label="角色名称"  width="220" align="center"></el-table-column>
                    <el-table-column label="角色描述"  align="center" prop="description"></el-table-column>
                    <el-table-column label="创建时间"   align="center" prop="createTime"></el-table-column>
                    <el-table-column label="操作"   align="center" v-if="permissions.indexOf(20)!=-1">
                        <template slot-scope="scope">
                           <el-button type="primary" size="mini" @click="checkRole(scope.row.id)">查看角色信息</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="pageSize"
                    layout="total, sizes, pager">
                </el-pagination>
            </el-row>
        </el-row>


        <el-dialog title="新增角色" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm" size="mini" class="demo-ruleForm">
                <el-form-item label="角色名称" prop="name">
                    <el-input  v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="角色权限" prop="permission">
                    <el-checkbox-group v-model="form.permission" @change="handleCheckedCitiesChange">
                        <el-checkbox v-for="item in dataOfpermission" :label="item.id" :key="item.id">{{ item.displayName }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
               
                <el-form-item label="描述">
                    <el-input  v-model="form.description" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')" size="mini">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" size="mini">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="角色信息" :visible.sync="dialogFormVisible1" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <el-form :model="checkedForm" label-width="120px"  ref="ruleForm" size="mini" class="demo-ruleForm">
                <el-form-item label="角色名称">
                    <el-input  v-model="checkedForm.name" autocomplete="off" disabled></el-input>
                </el-form-item>
                <el-form-item label="角色权限">
                    <el-checkbox-group v-model="checkedForm.permission" disabled>
                        <el-checkbox v-for="item in dataOfpermission" :label="item.id" :key="item.id">{{ item.displayName }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
               
                <el-form-item label="描述">
                    <el-input  v-model="checkedForm.description" autocomplete="off" disabled></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="editRole" size="mini" v-if="permissions.indexOf(18)!=-1">更 新</el-button>
                <el-button type="primary" @click="sureInfo" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </el-row>
</template>

<script>
    import {axiosGet,axiosPost} from '@/assets/ajaxFn'
    export default {
        data(){
            return{
                total:0,
                pageSize:50,
                tableData: [],
                checkedForm:{
                    name:'',
                    permission:[],
                    description:''
                },
                loading:false,
                    currentPage:1,
                    dialogFormVisible:false,
                    dialogFormVisible1:false,
                    form:{
                        name:'',
                        permission:[],
                        description:''
                    },
                    rules:{
                        name: [
                            { required: true, message: '请输入客户名称', trigger: 'blur' },
                            { min: 3, max: 25, message: '长度在 3 到 25 个字符', trigger: 'blur' }
                        ],
                        permission: [
                            { required: true, message: '请选择角色权限', trigger: 'blur' }
                        ]
                    },
                    id:'',
                    permissions:JSON.parse(sessionStorage.getItem('permission')),
                    dataOfpermission:[]
            }
        },
        methods:{
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getRoleList({currentPage:this.currentPage,pageSize:this.pageSize,keyword:this.searchName});
            },
            handleCheckedCitiesChange(val){
                console.log(val);
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getRoleList({currentPage:this.currentPage,pageSize:this.pageSize,keyword:this.searchName});
            },
            createUser(){
                this.dialogFormVisible=true;
            },
            checkRole(id){
                this.loading=true;
                axiosGet('/api/role/info',{id:id}).then(res=>{
                    if(res.code==0){
                        this.loading=false;
                        this.dialogFormVisible1=true;
                        this.id=id;
                        this.checkedForm=res.data;
                    }
                })
            },
            editRole(){
                this.dialogFormVisible1=false;
                axiosGet('/api/role/info',{id:this.id}).then(res=>{
                    if(res.code==0){
                        this.form=res.data;
                        this.dialogFormVisible=true;
                    }
                })
                
            },
            sureInfo(){
                this.id="";
                this.dialogFormVisible1=false;
            },
            addItem(arr,item){//新增白名单ip
                if(arr.length>8){
                    this.$message({message:'最多可以添加9个',type:'error'});
                    return false;
                }
                arr.push({
                    value: '',
                    key: Date.now(),
                    showAdd:true,
                    showMin:true
                });
                arr[0].showAdd=false;
                arr[0].showMin=false;
                let index=arr.indexOf(item);
                if(index!=0){
                    arr[index].showAdd=false;
                    arr[index].showMin=true;
                }
            },
            removeItem(arr,item){
                let index=arr.indexOf(item)
                if(index!=0){
                    arr.splice(index,1);
                    arr[arr.length-1].showAdd=true;
                }

            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    let addCustomRequest={
                        name:this.form.name||'',
                        permission:this.form.permission||[],
                        description:this.form.description||''
                    }
                    let url='',string='';
                    if(!this.id){
                        url='/api/role/add';
                        string="添加";
                    }else{
                        url='/api/role/update'
                        string="修改";
                        addCustomRequest.id=this.id;
                    }
                    axiosPost(url,addCustomRequest,'JSON').then(res=>{
                        if(res.code==0){
                            this.$message({message:`角色${string}成功`,type:'success'});
                            this.getRoleList({currentPage:1,pageSize:50});
                            this.dialogFormVisible=false;
                            this.id="";
                            this.resetForm('ruleForm')
                        }
                    })
                    
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.dialogFormVisible=false;
                let _this=this;
                setTimeout(function(){//此定时器是为了防止页面UI抖动，可移除
                    _this.edit=false;
                    _this.form={
                        name:'',
                        permission:'',
                        description:''
                    }
                },500)
                
            },
            async getRoleList(params){
                this.loading=true;
                let res=await axiosGet('/api/role/list',params);
                this.loading=false;
                if(res.code==0){
                        this.tableData=res.data;
                    }
            },
            async getPermissionList(){
                let res=await axiosGet('/api/permission/list');
                if(res.code==0){
                    this.dataOfpermission=res.data;
                }
            }
        },
        mounted() {
           this.getRoleList({currentPage:1,pageSize:50,keyword:this.searchName});
           this.getPermissionList();
        },
    }
</script>
<style>
   .is-checked .is-disabled + span.el-checkbox__label{
        color: #409EFF;
    }
</style>



// WEBPACK FOOTER //
// src/components/view/roleManager.vue